import React from 'react';
import { Alert, Spin, Table, Tag, Typography } from 'antd';
import { Link } from 'react-router-dom';

const { Text } = Typography;

const formatLimit = (lim) => {
  const val = lim.limit_value != null ? Number(lim.limit_value).toLocaleString() : '—';
  const unit = lim.unit_label || lim.metric_name || '';
  const period = lim.period ? ` / ${lim.period}` : '';
  const scoped = lim.applies_to_this_checkin_type ? ' (this type)' : '';
  return `${val} ${unit}${period}${scoped}`.trim();
};

const LinkedPlansPanel = ({ plans = [], loading = false, poolName }) => {
  if (loading) {
    return <Spin size="small" />;
  }

  if (!plans.length) {
    return (
      <Alert
        type="info"
        showIcon
        message="No plans include this benefit yet"
        description={
          poolName
            ? `Add the "${poolName}" benefit on a plan under Plans Management, then set limits there. This encounter type only gates who may check in.`
            : 'Select a limit pool to see which plans include it.'
        }
      />
    );
  }

  const columns = [
    {
      title: 'Plan',
      dataIndex: 'plan_name',
      render: (name, row) => (
        <Link to={`/plans/${btoa(String(row.plan_id))}`}>{name || `Plan #${row.plan_id}`}</Link>
      ),
    },
    {
      title: 'Benefit',
      dataIndex: 'benefit_included',
      width: 100,
      render: (v) => (
        <Tag color={v !== false ? 'green' : 'default'}>{v !== false ? 'Included' : 'Not on plan'}</Tag>
      ),
    },
    {
      title: 'Limits (read-only)',
      dataIndex: 'limits',
      render: (limits) => {
        const list = Array.isArray(limits) ? limits : [];
        if (!list.length) return <Text type="secondary">No limits configured</Text>;
        return (
          <ul style={{ margin: 0, paddingLeft: 18, fontSize: 12 }}>
            {list.map((lim, i) => (
              <li key={lim.limit_definition_id ?? lim.id ?? i}>{formatLimit(lim)}</li>
            ))}
          </ul>
        );
      },
    },
  ];

  return (
    <Table
      size="small"
      pagination={false}
      rowKey={(r) => r.plan_id}
      columns={columns}
      dataSource={plans}
    />
  );
};

export default LinkedPlansPanel;
